











import { Component, Vue, Prop } from 'vue-property-decorator';

import TitleOnboarding from '@/components/molecules/TitleOnboarding/TitleOnboarding.vue';
import RefundPolicy from '@/components/organisms/RefundPolicy/RefundPolicy.vue';

@Component({
  components: {
    RefundPolicy,
    TitleOnboarding
  }
})
export default class RefundPolicyPage extends Vue {
  @Prop({ default: false }) readonly page?: boolean;

  onSave() {
    this.$notification('Loyalty set up successfully', 'success');
  }
}
